import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Audit_logs_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="audit_logs" />;
  }
}
